import {
  AsyncPropSelector,
  ALL_MODULES,
  Loader,
  getTranslatedText,
  useIntl,
  CUSTOM_FIELDS_TYPE
} from '@nile/components';
import { AccountClient } from '@nile/graphql';
import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { GET_FIELDS } from '@nile/banyan/src/Graphql/Mutations/ticket';
import DefaultFieldsInput from './DefaultFieldsInput';
import CustomFieldInput from './CustomFieldsInput';

const ClosureFields = (props) => {
  const {
    fields,
    onChange,
    isBulkSection,
    noPortalTarget,
    customWidthClass,
    isDark,
    customLabelComponent,
    isUiDesignSystem,
    ticket,
    updateAllFields,
    customTextFieldUIProps,
    customTextFieldLabel,
    datePickerPortalId
  } = props;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fieldIdentifierInput = Object.keys(fields).map((el) => ({
    module: ALL_MODULES.ticket,
    columnName: el
  }));

  const getData = async () => {
    const response = await AccountClient.query({
      query: GET_FIELDS,
      variables: { input: fieldIdentifierInput }
    });
    if (updateAllFields)
      updateAllFields(response?.data?.getFields, ticket?.ticketId);
    setData(response?.data);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [Object.keys(fields)]);

  if (loading) {
    return (
      <div className="min-height-300 p20">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div
        className={`closure-fields-wrapper flex g20 w100 wrap pb20 ${
          isBulkSection ? '' : 'col'
        }`}
      >
        {data?.getFields.map((field) => {
          return (
            <>
              <div
                key={field?.id}
                className={`${
                  isBulkSection ? customWidthClass || 'w40' : 'w100'
                }`}
              >
                {field?.fieldCategory === 'DEFAULT' && (
                  <>
                    <DefaultFieldsInput
                      field={field}
                      value={fields}
                      fields={fields}
                      onChange={onChange}
                      key={field?.id}
                      noPortalTarget={noPortalTarget}
                      customLabelComponent={customLabelComponent}
                      isUiDesignSystem={isUiDesignSystem}
                      ticket={ticket}
                    />
                  </>
                )}

                {field?.fieldCategory === 'CUSTOM' && (
                  <>
                    <CustomFieldInput
                      field={field}
                      onChange={onChange}
                      value={fields?.[field?.columnName]}
                      fields={fields}
                      key={field?.id}
                      noPortalTarget={noPortalTarget}
                      customLabelComponent={customLabelComponent}
                      ticket={ticket}
                      customTextFieldUIProps={customTextFieldUIProps}
                      customTextFieldLabel={customTextFieldLabel}
                      datePickerPortalId={datePickerPortalId}
                    />
                  </>
                )}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default React.memo(ClosureFields);
